import {
  BzitResponse,
  BzitVehicle,
  BzitVehicleDetails,
  ServiceResult
} from '../../bzit';
import { SEARCH_URL } from '../../configs/env';
import { getVehicleDetails } from '../../provider/SearchProvider/fetcher';
import { fetchJson } from '../../utils/fetch';

export interface ListBookmarksResponse {
  vehicles: BzitVehicle[];
}

export interface ListBookmarkDetailsResponse {
  vehicles: BzitVehicleDetails[];
}

interface VehicleArgs {
  userId: string;
  vehicleId: string;
}

export const add = async ({
  userId,
  vehicleId
}: VehicleArgs): Promise<ServiceResult<{}>> => {
  try {
    const result = await fetchJson<BzitResponse<{}>>(
      `${SEARCH_URL}addWatchlist/${userId}/${vehicleId}`
    );
    if (result.resultCode === 0) {
      return { success: true, result };
    }
    throw new Error(result.resultMsg);
  } catch (error) {
    return { success: false, error };
  }
};

export const remove = async ({
  userId,
  vehicleId
}: VehicleArgs): Promise<ServiceResult<{}>> => {
  try {
    const result = await fetchJson<BzitResponse<{}>>(
      `${SEARCH_URL}delWatchlist/${userId}/${vehicleId}`
    );
    if (result.resultCode === 0) {
      return { success: true, result };
    }
    throw new Error(result.resultMsg);
  } catch (error) {
    return { success: false, error };
  }
};

interface ListArgs {
  userId: string;
  currency?: string;
}

export const list = async ({
  userId,
  currency = 'EUR'
}: ListArgs): Promise<ServiceResult<ListBookmarksResponse>> => {
  try {
    const result = await fetchJson<BzitResponse<ListBookmarksResponse>>(
      `${SEARCH_URL}getWatchlist/${userId}/${currency}`
    );
    if (result.resultCode === 0) {
      return { success: true, result };
    }
    throw new Error(result.resultMsg);
  } catch (error) {
    return { success: false, error };
  }
};

export const listDetails = async ({
  userId,
  currency = 'EUR'
}: ListArgs): Promise<ServiceResult<ListBookmarkDetailsResponse>> => {
  try {
    const listBookmarksResponse = await list({ userId, currency });
    if (listBookmarksResponse.success) {
      const { vehicles, ...restResult } = listBookmarksResponse.result;
      const details = await Promise.all(
        vehicles.map(({ vehicleId }) =>
          getVehicleDetails({ vehicleId, currency })
        )
      );
      const vehicleDetails = details.reduce(
        (acc: BzitVehicleDetails[], detailResponse, index) => {
          if (detailResponse.success) {
            acc.push(detailResponse.result);
          } else {
            console.warn(
              `BookmarkService.listDetails: ${
                vehicles[index].vehicleId
              } not found!`
            );
          }
          return acc;
        },
        []
      );
      return {
        success: true,
        result: {
          ...restResult,
          vehicles: vehicleDetails
        }
      };
    } else {
      throw listBookmarksResponse.error;
    }
  } catch (error) {
    return { success: false, error };
  }
};
